import { Card, CardContent, CardHeader, CardTitle } from '@shared/components';
import { PurchaseLinesTable } from './PurchaseLinesTable';
import type { PurchaseView } from '../services/purchaseSnapshot';

interface Props {
    purchase: PurchaseView;
}

const headingId = 'agreement-purchase-heading';

/** Dumb: receives the already-normalised `PurchaseView` (built once, in
 *  AgreementDetail, via `buildPurchaseView`) and renders it. Never reads
 *  `purchase_snapshot` itself. */
export function AgreementPurchasePanel({ purchase }: Props) {
    return (
        <Card>
            <CardHeader>
                <CardTitle>
                    <span id={headingId}>What was sold</span>
                </CardTitle>
            </CardHeader>
            <CardContent>
                <section aria-labelledby={headingId} className="space-y-6">
                    <div>
                        <h3 className="mb-1 text-sm font-semibold text-mp-foreground">
                            Product
                        </h3>
                        {purchase.product ? (
                            <div>
                                <p className="text-sm text-mp-foreground">
                                    {purchase.product.name ?? 'Unnamed'}
                                </p>
                                {purchase.product.description && (
                                    <p className="text-sm text-mp-muted">
                                        {purchase.product.description}
                                    </p>
                                )}
                            </div>
                        ) : (
                            <p className="text-sm text-mp-muted">
                                No product was recorded on this agreement.
                            </p>
                        )}
                    </div>

                    <PurchaseLinesTable
                        title="Services"
                        lines={purchase.services}
                        dateColumnHeader="Due date"
                        emptyMessage="No services were recorded on this agreement."
                    />

                    <PurchaseLinesTable
                        title="Optional Extras"
                        lines={purchase.addOns}
                        dateColumnHeader="Due date"
                        emptyMessage="No optional extras were recorded on this agreement."
                    />
                </section>
            </CardContent>
        </Card>
    );
}
